import axios from 'axios';
import Cookies from 'universal-cookie';

const service = axios.create({
    baseURL: process.env.API_URL
});

// Add a request interceptor
service.interceptors.request.use(
    function (config) {
        if (config!.headers!.url !== '/account/sign-in-with-email') {
            const cookies = new Cookies();

            const token = cookies.get('session');
            config!.headers!.Authorization = 'Bearer ' + token;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

// Add a response interceptor
service.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export default service;
